import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import JoinEvent from "./JoinEvent";

createRoot(document.getElementById("tmt-join-event")).render(
	<StrictMode>
		<JoinEvent/>
	</StrictMode>,	
);